import { CloseXIcon } from '@jouzen/ecom-components/icons/CloseXIcon';
import { useTranslations } from 'next-intl';
import type { OverlayTriggerState } from 'react-stately';

export interface CloseButtonProps {
  readonly close: OverlayTriggerState['close'];
}

const CloseButton = ({ close }: CloseButtonProps) => {
  const t = useTranslations();

  return (
    <button
      className="absolute top-4 right-4 z-10 hidden flex-col items-center text-gray-400 md:flex"
      data-cy="leadership_profile_modal_close"
      onClick={close}
      type="button"
    >
      <span
        aria-hidden="true"
        className="mb-3 flex size-8 items-center justify-center rounded-full border border-solid border-current"
      >
        <CloseXIcon className="size-6" />
      </span>
      <span
        className="text-xs leading-5 tracking-widest uppercase"
        style={{ writingMode: 'vertical-lr' }}
      >
        {t('close')}
      </span>
    </button>
  );
};

export default CloseButton;
